// src/components/resume/ResumeSection.js
import React from 'react';
import styles from '../../styles/pages/Resume.module.css';

/**
 * ResumeSection component for organizing different sections of the resume
 * 
 * @param {Object} props - Component props
 * @param {string} props.id - Section ID for anchor links
 * @param {string} props.title - Section title
 * @param {ReactNode} props.children - Section content
 */
export function ResumeSection({ id, title, children }) {
  return (
    <section id={id} className={styles.resumeSection}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <div className={styles.sectionContent}>
        {children}
      </div>
    </section>
  );
}